export default __webpack_public_path__ + "images/2e3360a91e668af2d71fb86ec12db217.png";